var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisitWebsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212B36;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.3,11.1c-0.8-4-2.6-6.6-4.3-6.6s-3.5,2.5-4.3,6.6H20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.2,16c0,1.1,0.1,2.2,0.2,3.3h9.2c0.1-1.1,0.2-2.2,0.2-3.3c0-1.1-0.1-2.2-0.2-3.3h-9.2 C11.3,13.8,11.2,14.9,11.2,16L11.2,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.7,20.9c0.8,4,2.6,6.6,4.3,6.6s3.5-2.5,4.3-6.6H11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,11.1h5c-0.8-1.8-1.9-3.3-3.4-4.6c-1.5-1.2-3.2-2.1-5-2.5C20.1,5.4,21.3,7.9,21.9,11.1L21.9,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.6,12.7h-5.4c0.1,1.1,0.2,2.2,0.2,3.3c0,1.1-0.1,2.2-0.2,3.3h5.4C28.1,17.1,28.1,14.9,27.6,12.7L27.6,12.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.6,28c1.8-0.4,3.5-1.3,5-2.5c1.5-1.2,2.6-2.8,3.4-4.6h-5C21.3,24.1,20.1,26.6,18.6,28L18.6,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.1,20.9H5c0.8,1.8,1.9,3.3,3.4,4.6c1.5,1.2,3.2,2.1,5,2.5C11.9,26.6,10.7,24.1,10.1,20.9L10.1,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.4,4c-1.8,0.4-3.5,1.3-5,2.5C6.9,7.7,5.8,9.3,5,11.1h5C10.7,7.9,11.9,5.4,13.4,4L13.4,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.6,16c0-1.1,0.1-2.2,0.2-3.3H4.4c-0.6,2.1-0.6,4.4,0,6.6h5.4C9.7,18.2,9.6,17.1,9.6,16L9.6,16z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitWebsite);
export default __webpack_public_path__ + "static/media/visit_website.7dd46ed147e903c867da0df3ad792bf2.svg";
export { ForwardRef as ReactComponent };